
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.69 35a40.82 40.82 0 017.16-9.27c3.06-2.85 6.64-5 10-7.38a24.06 24.06 0 009.5-12.79c.21-.63-1.69-.21-1.9.43a24.54 24.54 0 01-4.85 8.53 36.72 36.72 0 01-6 4.75c-3.16 2.21-6.53 4.32-9.17 7.06a37.54 37.54 0 00-6.53 8.75c-.53.73 1.47.42 1.79-.11z","fill":"#06132f"}}),_c('path',{attrs:{"d":"M32.19 4.51c-4 3-9.38 2.84-13.91 4.53A9.36 9.36 0 0012 19.16a12.3 12.3 0 006.64 9.49c2.42 1.26 5.27 2 7.91 1.16s4.53-3.27 5.8-5.59c3.05-5.59 4-12.33 1.37-18.34a3 3 0 00-.85-1c-.1-.11-.63-.43-.52 0a18.87 18.87 0 01-.11 15.28 19.53 19.53 0 01-4 6.43 8.06 8.06 0 01-7.49 1.9 9 9 0 01-6.32-4.32 12.46 12.46 0 01-1.06-4.33c-.21-4.53 2.32-7.9 6.54-9.38C24.29 8.83 29.77 8.83 33.67 6c.21-.23-1.06-1.7-1.48-1.49z","fill":"#4caf50"}}),_c('path',{attrs:{"d":"M25.87 11.47c-.32 1.26-.74 2.53-.95 3.79a1.66 1.66 0 00.63 1.27.84.84 0 00.53.21.33.33 0 00.31-.32 17 17 0 01.95-3.79 1.39 1.39 0 00-.1-.64c-.11-.21-.32-.42-.43-.63-.42-.21-.84-.31-.94.11zM22.81 21.06c-.21 0-.53-.11-.84-.11a3 3 0 01-.95-.21c-.63-.1-1.27-.31-1.9-.42-.42-.1-.53.42-.42.74a1.36 1.36 0 00.94 1.05 26.19 26.19 0 004 .74.35.35 0 00.32-.32 1.38 1.38 0 00-.11-.63c-.32-.42-.63-.84-1.05-.84z","fill":"#06132f"}})])
          )
        }
      }
    